import * as React from 'react'
import { Elements } from '@stripe/react-stripe-js'
import { connect } from 'react-redux'
import * as actions from '../../../actions'
import { StripeCredentials } from '../../../models/types'
import { loadStripe } from '../../atoms/stripe'
import Loading from '@doordash/component-loading'
import { LoadingContainer } from './styles'

type StripeElementsProps = {
  dasherId: string
}

type ReduxProps = {
  stripeCredentials?: StripeCredentials
  getStripeCredentials?: (dasherId: string) => Promise<any>
}

export const StripeElements: React.FC<StripeElementsProps & ReduxProps> = ({
  children,
  dasherId,
  getStripeCredentials,
  stripeCredentials,
}) => {
  const [stripe, setStripe] = React.useState(null)
  React.useEffect(() => {
    if (dasherId) {
      getStripeCredentials(dasherId).then(() => {
        if (stripeCredentials.publicKey) {
          loadStripe(setStripe, stripeCredentials.publicKey)
        }
      })
    }
  }, [dasherId, getStripeCredentials, stripeCredentials.publicKey])

  if (stripe) {
    return <Elements stripe={stripe}>{children}</Elements>
  }

  return (
    <LoadingContainer>
      <Loading />
    </LoadingContainer>
  )
}

const mapStateToProps = state => ({
  stripeCredentials: state.stripeCredentials,
})

const mapDispatchToProps = {
  getStripeCredentials: actions.getStripeCredentials,
}

export default connect(mapStateToProps, mapDispatchToProps)(StripeElements)
